import React from 'react';
import './index.css';
import { Link } from 'react-router-dom';

export default function Footer({ }): JSX.Element {
  return (
    <footer className="workspace-footer">
      <div className="footer-wrapper">
        <div className="footer-logo-wrapper">
          <span className="footer-logo">Astin</span>
          <div className="footer-split"></div>
          <span className="footer-logo-copyright">2010 - 2023 ©</span>
        </div>
        <div className="footer-nav-wrapper">
          <Link to="/" className="footer-nav-link">Політика конфіденційності</Link>
          <div className="footer-split"></div>
          <Link to="/" className="footer-nav-link">Правила користування</Link>
        </div>
        <div className="footer-text">
          Створено&nbsp;<Link to="/" className="footer_logo_link"> ASTIN IT</Link>
        </div>
      </div>
    </footer>
  );
}

